import React, { memo } from 'react'

import footerData from '@/assets/data/footer.json'
import { AppFooterWrapper } from './style'
import IconSina from '@/assets/svg/IconSina'
import IconWeixin from '@/assets/svg/IconWeixin'
import IconLogo from '@/assets/svg/IconLogo'

const AppFooter = memo(() => {
  return (
    <AppFooterWrapper>
      <div className="container">
        <div className="links">
          {footerData.map((item, index) => {
            return (
              <dl className="item-group" key={index}>
                <dt className="item-title">{item.name}</dt>
                {item.list.map((iten, indey) => {
                  return (
                    <dd className="item-cell" key={indey}>
                      {iten}
                    </dd>
                  )
                })}
              </dl>
            )
          })}
        </div>
        <div className="info">
          <div className="left">
            <div className="logo">
              <IconLogo />
            </div>
            <div className="text">
              <div>
                <a href="http://www.baidu.com">京ICP备16017121号</a>
                <a href="http://www.baidu.com">京ICP证 160773号</a>
                <img className="icon" src={require('@/assets/img/public_security_bureau_logo.png')} alt="" />
                <a href="http://www.baidu.com">京公网安备 11010502032345号</a>
                <span>安彼迎网络（北京）有限公司</span>
                <img className="icon" src={require('@/assets/img/electronic_business_license.png')} alt="" />
                <a href="http://www.baidu.com">营业执照</a>
              </div>
              <div>
                <span>© 2023 Airbnb, Inc. All rights reserved.</span>
                <a href="http://www.baidu.com">条款</a>·<a href="http://www.baidu.com">隐私政策</a>·<a href="http://www.baidu.com">网站地图</a>·
                <span>· 全国旅游投诉渠道 12301</span>
              </div>
            </div>
          </div>
          <div className="right">
            <a className="tag" href="http://www.baidu.com">
              <IconSina />
            </a>
            <a className="tag" href="http://www.baidu.com">
              <IconWeixin />
            </a>
          </div>
        </div>
      </div>
    </AppFooterWrapper>
  )
})

export default AppFooter
